<template>
  <div>
    <div class="vx-col w-full mb-base">
      <vx-card class="mb-2">
        <div class="flex flex-row items-center justify-center">
          <vs-button class="w-1/6 m-4" icon="person_outline" size="large" to="/search/name">Búsqueda por nombre</vs-button>
          <vs-button class="w-1/6 m-4" icon="subtitles" size="large" to="/search/plate">Búsqueda por placa</vs-button>
          <vs-button class="w-1/6 m-4" icon="directions_car" size="large" to="/search/chassis">Búsqueda por chasis</vs-button>
          <vs-button class="w-1/6 m-4" icon="brightness_high" size="large" to="/search/motor">Búsqueda por motor</vs-button>
        </div>
      </vx-card>
      <vx-card class="mb-2">
        <div class="flex flex-row">
          <vx-card class="w-1/2 mb-2 mr-4" title="Top 10 personas">
            <div class="flex flex-row w-full">
              <apexcharts class="flex w-full" type="bar" height="400" :options="chart1.chartOptions" :series="chart1.series"></apexcharts>
            </div>
          </vx-card>
          <vx-card class="w-1/2 mb-2" title="Top 10 vehículos">
            <div class="flex flex-row w-full">
              <apexcharts class="flex w-full" type="bar" height="400" :options="chart2.chartOptions" :series="chart2.series"></apexcharts>
            </div>
          </vx-card>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts';

  export default {
    data() {
      return {
        loaded: false,
        data: [],
        chart1: {
          series: [],
          chartOptions: {
            chart: { id: 'chart1' },
            legend: {
              show: false
            },
            plotOptions: {
              bar: {
                barHeight: '100%',
                distributed: true,
                horizontal: true,
                dataLabels: {
                  position: 'bottom'
                }
              }
            },
            dataLabels: {
              enabled: true,
              textAnchor: 'start',
              formatter: function(val, opt) {
                return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
              },
              offsetX: 0,
              dropShadow: {
                enabled: true
              }
            },
            yaxis: {
              labels: {
                show: false
              }
            }
          }
        },
        chart2: {
          series: [],
          chartOptions: {
            chart: { id: 'chart2' },
            legend: {
              show: false
            },
            plotOptions: {
              bar: {
                barHeight: '100%',
                distributed: true,
                horizontal: true,
                dataLabels: {
                  enabled: false,
                  position: 'bottom'
                }
              }
            },
            dataLabels: {
              enabled: true,
              textAnchor: 'start',
              formatter: function(val, opt) {
                return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
              },
              offsetX: 0,
              dropShadow: {
                enabled: true
              }
            },
            yaxis: {
              labels: {
                show: false
              }
            }
          }
        }
      }
    },
    components: {
      apexcharts: VueApexCharts
    },
    computed: {
      api() {
        return this.$store.getters.getParameter('connection').apiURL;
      }
    },
    methods: {
      getTop10People() {
        const self = this;
        this.$http.post(`${this.api}/statistics/top10people`).then(response => {
          if (response.data.success) {
            if (response.data.data) {
              let data = [];
              for (let i = 0; i < response.data.data.length; i++) {
                data.push({x: response.data.data[i].nombrePiloto, y: response.data.data[i].cantidad});
              }
              self.chart1.series.push({name: 'Siniestros', data: data});
            } else {
              self.data = [];
            }
            self.gridReady = true;
          } else {
            self.$vs.notify({
              title: 'Error al cargar Top 10 de personas',
              text: response.data.message,
              color: 'danger'
            });
          }
          self.loaded = true;
        }).catch(error => {
          self.loaded = true;
          this.$vs.loading.close();
          var errorMessage = '';
          if (error.message) {
            errorMessage = error.message;
          } else if (error.response) {
            errorMessage = error.response.data.ErrorMessage;
          } else {
            errorMessage = 'Error de conectividad'
          }
          self.$vs.notify({
            title: 'Error al cargar Top 10 de personas',
            text: errorMessage,
            color: 'danger'
          });
        });
      },
      getTop10Auto() {
        const self = this;
        this.$http.post(`${this.api}/statistics/top10auto`).then(response => {
          if (response.data.success) {
            if (response.data.data) {
              let data = [];
              for (let i = 0; i < response.data.data.length; i++) {
                data.push({x: response.data.data[i].descripcionVehiculo, y: response.data.data[i].cantidad});
              }
              self.chart2.series.push({name: 'Siniestros', data: data});
            } else {
              self.data = [];
            }
            self.gridReady = true;
          } else {
            self.$vs.notify({
              title: 'Error al cargar Top 10 de vehículos',
              text: response.data.message,
              color: 'danger'
            });
          }
          this.$vs.loading.close();
          self.loaded = true;
        }).catch(error => {
          self.loaded = true;
          this.$vs.loading.close();
          var errorMessage = '';
          if (error.message) {
            errorMessage = error.message;
          } else if (error.response) {
            errorMessage = error.response.data.ErrorMessage;
          } else {
            errorMessage = 'Error de conectividad'
          }
          self.$vs.notify({
            title: 'Error al cargar Top 10 de personas',
            text: errorMessage,
            color: 'danger'
          });
        });
      }
    },
    mounted() {
      this.$vs.loading({
        text: 'Cargando estadísticas iniciales',
        type: 'point'
      });
      this.getTop10People();
      this.getTop10Auto();
    }
  }

</script>
